import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import * as S from './styles';

type BackButtonProps = {
    label: React.ReactNode;
    to?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
};

export const BackButton: React.FC<BackButtonProps> = ({
    label,
    to,
    onClick,
    style,
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
            return;
        }

        if (to) {
            navigate(to);
            return;
        }

        navigate(-1);
    };

    return (
        <S.BackButtonStyled
            type="link"
            icon={<ArrowLeft size={15} />}
            onClick={handleClick}
            style={style}
        >
            {label}
        </S.BackButtonStyled>
    );
};

export default BackButton;
